import React, { useEffect, useState } from "react";
import { InputBase, Box, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const CustomeSearchInput = ({
  placeholder = "Search",
  value,
  onChange,
  onKeyDown,
  width = 0,
  borderRadius = '8px',
  fontSize = 14,
  backgroundColor,
  textColor,
  iconColor,
  borderColor,
  onSearch,
  showIcon = true
}) => {
    const [searchText, setSearchText] = useState('');
  const theme = useTheme();

  useEffect(() => {
    setSearchText(value || '');
  }, [value]);

  const displayValue = value !== undefined ? value : searchText;

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (value === undefined) {
      setSearchText(newValue);
    }

    onSearch?.(newValue);
    onChange?.(e);
  };

  const effectiveTextColor = textColor || theme.palette.background.text;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: `1px solid ${borderColor || theme.palette.custom.borderColor}`,
        borderRadius,
        padding: "4px 12px",
        backgroundColor: backgroundColor || theme.palette.background.paper,
        color: effectiveTextColor,
      }}
    >
          {showIcon && (
        <SearchIcon
          sx={{ color: iconColor || effectiveTextColor, mr: 1, fontSize: 18 }}
        />
      )}
      <InputBase
        placeholder={placeholder}
        // value={value}
        // onChange={onChange}
        value={displayValue}
        onChange={handleInputChange}
        onKeyDown={onKeyDown}
        sx={{
          flex: 1,
          fontSize,
          color: effectiveTextColor,
          "& .MuiInputBase-input": {
            color: effectiveTextColor,
          },
          "& .MuiInputBase-input::placeholder": {
            color: effectiveTextColor,
            opacity: 1,
          },
        }}
        inputProps={{ "aria-label": placeholder }}
      />
    </Box>
  );
};

export default CustomeSearchInput;

